import React from 'react';
import './TimeComparisonModal.css';

const TimeComparisonModal = ({ onClose, onSelect, currentPeriod = 'week' }) => {
    const periods = [
        { id: 'week', label: 'Previous Week' },
        { id: 'month', label: 'Previous Month' },
        { id: 'year', label: 'Previous Year' }
    ];

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="comparison-modal" onClick={e => e.stopPropagation()}>
                <h3 className="modal-title">Compare to</h3>
                {periods.map(period => (
                    <button
                        key={period.id}
                        className={`period-option ${currentPeriod === period.id ? 'active' : ''}`}
                        onClick={() => {
                            onSelect(period.id);
                            onClose();
                        }}
                    >
                        {period.label}
                    </button>
                ))}
            </div>
        </div>
    );
};

export default TimeComparisonModal; 